import type { CustomReportSummary } from "@/types/reports";

const plural = (n: number, word: string) => `${n} ${word}${n === 1 ? "" : "s"}`;

/** What a report holds, in a few words: "3 sheets", or "2 pages · 5 blocks". */
export function reportContents(
  report: Pick<CustomReportSummary, "format" | "page_count" | "block_count" | "sheet_count">,
): string {
  return report.format === "spreadsheet"
    ? plural(report.sheet_count, "sheet")
    : `${plural(report.page_count, "page")} · ${plural(report.block_count, "block")}`;
}
